import React, { useState, useRef, useEffect } from "react";
import { InputMask } from "primereact/inputmask";
import { Toast } from "primereact/toast";

export default function InputTextCPF(props) {
  const [value, setValue] = useState(props.value || "");
  const [error, setError] = useState(false);
  const toast = useRef(null);

  useEffect(() => {
    if (props.setError) {
      props.setError(error);
    }
  }, [error, props.setError]);

  const formatCPF = (cpf) => {
    return cpf
      .replace(/\D/g, "") // Remove tudo que não for número
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1-$2")
      .slice(0, 14); // Garante o tamanho correto
  };

  const validateCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, ""); // Remove formatação

    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false; // Evita CPFs inválidos

    const calcDigit = (cpf, factors) => {
      let sum = 0;
      for (let i = 0; i < factors.length; i++) {
        sum += cpf[i] * factors[i];
      }
      const mod = sum % 11;
      return mod < 2 ? 0 : 11 - mod;
    };

    const factors1 = [10, 9, 8, 7, 6, 5, 4, 3, 2];
    const factors2 = [11, ...factors1];

    const firstDigit = calcDigit(cpf, factors1);
    const secondDigit = calcDigit(cpf + firstDigit, factors2);

    return firstDigit == cpf[9] && secondDigit == cpf[10];
  };

  const handleChange = (event) => {
    const rawValue = event.target.value.replace(/\D/g, ""); // Apenas números
    const formattedValue = formatCPF(rawValue);
    setValue(formattedValue);

    const isValid = rawValue.length === 11 && validateCPF(rawValue);
    setError(!isValid);

    if (props.onChange) {
      props.onChange({
        ...event,
        target: { 
          ...event.target, 
          name : props.name,
          value: formattedValue },
      });
    }
  };

  const handleBlur = () => {
    if (error) {
      toast.current.show({
        severity: "error",
        summary: "CPF inválido",
        detail: "O CPF informado é inválido! Verifique!",
        life: 3000,
      });
    }
  };

  return (
    <div>
      <InputMask
        mask="999.999.999-99"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        className={`p-inputtext ${error ? "p-invalid" : ""}`}
        {...props}
      />
      {error && (
        <small className="p-error" style={{ display: "block", marginTop: "5px" }}>
          CPF inválido
        </small>
      )}
      <Toast ref={toast} />
    </div>
  );
}
